const NAME_SPACE = 'StepsCarouselComponent';

export { NAME_SPACE };
